import React from 'react';
import { connect } from 'react-redux';
import StoredLayout from 'layouts/StoredLayout';
import AnalyticsCard from 'pages/analytics/components/AnalyticsCard';
import LoadingSpinner from 'cyder/loadingSpinner/LoadingSpinner';
import { Doughnut, Chart } from 'react-chartjs-2';
import CyderDoughnut from 'pages/analytics/components/charts/CyderDoughnut';
import { AnalyticsBigText, AnalyticsNormalText } from 'pages/analytics/components/AnalyticsTextComponents';
import { getCertifiedProductDistributionAnalytic } from 'actions/analytics/certificateAnalyticsAction';
var randomColor = require('randomcolor');
var tinygradient = require('tinygradient');

var gradient = tinygradient('#36eb87', '#ffce56', '#36a2eb', '#ff8686');
// var gradient = tinygradient('#68C0D6', '#78BE20');

var generateGradient = step => {
    var colorsRgb = gradient.rgb(step);
    return colorsRgb;
};

var randomHexColor = () =>
    randomColor({
        luminosity: 'dark',
        hue: 'green',
        format: 'rgba',
        alpha: 0.6,
    });

class CertifiedProductDistribution extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            legendconfig: {
                legend: {
                    onClick: null,
                },
            },
        };
    }

    componentDidMount() {
        this.props.load().then(res => {
            var col = generateGradient(res.data.length);
            let labels = [];
            let data = [];
            let backgroundColor = [];
            let total = 0;
            let hoverBackgroundColor = [];
            res.data.forEach((element, i) => {
                if (element.productCategory != null) {
                    labels.push(element.productCategory);
                    data.push(element.count);
                    total += element.count;
                    backgroundColor.push(col[i].toHexString());
                }
            });
            this.setState({
                data,
                backgroundColor,
                hoverBackgroundColor,
                labels,
                total,
                centerText: total,
            });
        });
    }

    render() {
        return (
            <AnalyticsCard title={`Certified Products Distribution`} {...this.props.stlyle}>
                {this.state.data == null ? (
                    <LoadingSpinner />
                ) : (
                    <React.Fragment>
                        <CyderDoughnut {...this.state} />
                    </React.Fragment>
                )}
            </AnalyticsCard>
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        ownProps,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        load: () => {
            return dispatch(getCertifiedProductDistributionAnalytic());
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(StoredLayout(CertifiedProductDistribution));
